import { Nav } from "./Nav"

export const Contact = () => {

    return (
        <div>
            <Nav />
            <h2>
                Hello, this is the contact page
            </h2>
            <p>the best way to contact me is email!</p>
            {/* <button onClick={() => { throw new Error("This is your first error!"); }}>Break the world</button>; */}
        </div>
    )
}